// Ported from nenda-autoplayer's src/components/Playback/CountDownOverlay.tsx.
// RN `View`/`Text`/`StyleSheet` -> plain DOM, logic and layout unchanged.
import React from "react";

interface CountdownOverlayProps {
  remainingSeconds: number;
}

const CountdownOverlay: React.FC<CountdownOverlayProps> = ({
  remainingSeconds,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 10,
        right: 10,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        padding: "5px 10px",
        borderRadius: 5,
      }}
    >
      <span style={{ color: "#fff", fontSize: 16 }}>
        {remainingSeconds} sec
      </span>
    </div>
  );
};

export default CountdownOverlay;
